<template>
  <div>
    <!-- Organization list -->
    <div class="">
      <vs-table
        id="org-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              v-if="checkPermissionSlug(['organization_create'])"
              @click="addPage"
              class="btn-add-new p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium border border-solid d-theme-border-grey-light"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base">Add {{ module_name }}</span>
            </div>

            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <!-- <vs-th sort-key="Gurudwara.name">Vertical Thumbnail</vs-th> -->
          <vs-th sort-key="Gurudwara.name">Organization Name</vs-th>
          <vs-th>Admin Mail</vs-th>
          <vs-th sort-key="Gurudwara.country.country_name">Country</vs-th>
          <vs-th sort-key="Gurudwara.state.name">State</vs-th>
          <vs-th sort-key="Gurudwara.city.name">City</vs-th>
          <vs-th v-if="checkRolesByIds(['admin'])">Index</vs-th>
          <vs-th v-if="checkPermissionSlug(['organization_edit'])" sort-key="status">Featured</vs-th>
          <vs-th v-if="checkPermissionSlug(['organization_edit'])" sort-key="status">Visible</vs-th>
          <vs-th v-if="checkPermissionSlug(['organization_youtube_live'])">Youtube Live</vs-th>
          <vs-th v-if="checkPermissionSlug(['organization_edit']) || checkPermissionSlug(['organization_admin_list']) || checkPermissionSlug(['organization_delete'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ page * length - (length - i - 1) }}
              </vs-td>
              <!-- <vs-td>
              <img :src="tr.vertical_thumbnail" height="100" width="100" alt="" srcset="" />
            </vs-td> -->
              <vs-td class="text-left">
                <span class="cursor-pointer" v-if="checkPermissionSlug(['organization_edit'])" @click.stop="toggleEditGurudwaraModal(tr._id, $event)" v-tooltip="{ content: `Edit ${tr.name}` }">{{
                  tr.name || '-'
                }}</span>
                <span v-else>{{ tr.name || '-' }}</span>
              </vs-td>
              <vs-td class="text-left">
                <ul>
                  <li v-for="(value, index) in tr.admin" :key="index">
                    {{ value.email }}
                  </li>
                </ul>
              </vs-td>
              <vs-td class="text-left">
                <p class="capitalize">{{ tr.country ? tr.country.country_name : '-' }}</p>
              </vs-td>
              <vs-td class="text-left">
                <p class="capitalize">{{ tr.state ? tr.state.name : '-' }}</p>
              </vs-td>
              <vs-td>
                <p class="capitalize">{{ tr.city ? tr.city.name : '-' }}</p>
              </vs-td>
              <vs-td class="text-left w-1/6" v-if="checkRolesByIds(['admin'])">
                <vs-input
                  v-if="tr.is_active"
                  v-model="tr.featured_index"
                  v-validate="'required'"
                  type="number"
                  class="w-1/2"
                  @click.stop
                  @keydown.enter="updateIndexPosition(tr._id, tr.featured_index)"
                />
                <span v-else> - </span>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['organization_edit'])">
                <vs-switch
                  icon-pack="feather"
                  vs-icon-on="icon-check-circle"
                  vs-icon-off="icon-slash"
                  color="primary"
                  :value="tr.is_featured"
                  @click.stop="updateFeaturedStatus(tr._id, !tr.is_featured)"
                >
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['organization_edit'])">
                <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                  <span slot="on"></span>
                  <span slot="off"></span>
                </vs-switch>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['organization_youtube_live'])">
                <vs-checkbox
                  icon-pack="feather"
                  icon="icon-youtube"
                  :value="tr.go_live_on_youtube"
                  @click.native.stop="proccedLiveYoutube(tr._id, !tr.go_live_on_youtube)"
                  color="danger"
                ></vs-checkbox>
              </vs-td>
              <vs-td v-if="checkPermissionSlug(['organization_edit', 'organization_admin_list', 'organization_delete', 'organization_view'])">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                  <div class="p-4 border border-solid d-theme-border-grey-light cursor-pointer flex items-center justify-between font-medium">
                    Actions
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu class="locations__actions">
                    <!-- <vs-dropdown-item v-if="checkPermissionSlug(['organization_invite_gurudwara']) && !tr.admin" @click.stop="inviteMember(tr._id)">
                      <feather-icon icon="SendIcon" svgClasses="h-5 w-5  mr-4 hover:text-primary cursor-pointer" /> Invite Organization Admin
                    </vs-dropdown-item> -->
                    <vs-dropdown-item v-if="checkPermissionSlug(['organization_admin_list'])" @click.stop="manageOrganizationAdmin(tr._id)">
                      <feather-icon icon="SendIcon" svgClasses="h-5 w-5  mr-4 cursor-pointer" /> Manage Organization Admin
                    </vs-dropdown-item>

                    <vs-dropdown-item v-if="checkPermissionSlug(['service_request_list'])" @click.stop="toggleServiceReq(tr._id)">
                      <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5 mr-4 cursor-pointer" /> Service Requests List
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="checkPermissionSlug(['organization_edit', 'organization_view'])" @click.stop="toggleEditGurudwaraModal(tr._id, $event)">
                      <feather-icon :icon="checkPermissionSlug(['organization_edit']) ? 'EditIcon' : 'EyeIcon'" svgClasses="h-5 w-5 mr-4 cursor-pointer" />
                      {{ checkPermissionSlug(['organization_edit']) ? 'Edit' : 'View' }} {{ module_name }}
                    </vs-dropdown-item>
                    <vs-dropdown-item v-if="checkPermissionSlug(['organization_delete'])" @click.stop="deleteRecord(tr._id)">
                      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 cursor-pointer" /> Delete
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
      <!-- <vs-popup button-accept="false" button-cancel="false" :active.sync="popupActive" :title="`Invite Gurudwara Admin`" class="small_modal">
        <div class="vx-row px-5 vs-con-loading__container">
          <div class="vx-col px-0 w-full">
            <div class="mt-2 mb-3">
              <label for="Email">Mail</label>
              <vs-input id="Email" class="w-full" v-model="form.email" v-validate="'required|min:1|email'" name="Email" icon="icon icon-mail" icon-pack="feather" placeholder="Please add Email" />
              <span class="text-danger text-sm" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
            </div>
            <div class="mt-4">
              <div class="w-full px-0 justify-items-center">
                <vs-button class="text-sm py-3 px-5" color="dark" @click.stop="inviteMember()"> Cancel </vs-button>
                <button
                  id="invite-org"
                  class="ml-2 vs-con-loading__container text-sm vs-component vs-button vs-button-primary vs-button-filled py-3 px-5"
                  @click.stop="inviteGuruAdmin"
                  type="submit"
                >
                  Invite
                </button>
              </div>
            </div>
          </div>
        </div>
      </vs-popup> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'OrganizationList',

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    form: {
      email: '',
      gurudwara: ''
    },
    checkBox2: false,
    popupActive: false,
    module_name: 'Organization',
    action_module: 'organization'
  }),

  /** computed */
  computed: {
    ...mapState('organization', ['records', 'total', 'FilteredCount', 'listLoading', 'createLoading']),
    ...mapState('auth', ['roles']),
    ...mapGetters('auth', ['checkPermissionSlug', 'checkRolesByIds']),
    validateForm() {
      return !this.errors.any()
    },
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    /** Easy Dynamic Action Caller */
    $act(action, payload) {
      return this.$store.dispatch(`${this.action_module}/${action}`, payload)
    },

    updateIndexPosition(id, featured_index) {
      if (featured_index > 0) {
        this.$act('manageIndexNumber', { id, featured_index })
          .then(({ message }) => {
            this.getData()
            this.$vs.notify({ title: 'Success', text: message, color: 'success' })
          })
          .catch(({ message }) => {
            this.$vs.notify({ title: 'Error', text: message, color: 'primary' })
          })
      }
    },

    inviteMember(id) {
      this.form.gurudwara = id
      this.popupActive = !this.popupActive
    },

    manageOrganizationAdmin(id) {
      this.$router.push(`/${this.action_module}/${id}/organization-admin-list`)
    },

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    getData() {
      this.$act('get', { limit: this.length, page: this.page, search: this.search })
    },

    addPage() {
      this.$router.push(`/${this.action_module}/add`)
    },

    toggleEditGurudwaraModal(id, event) {
      const editUrl = `/${this.action_module}/${id}/edit`
      if (event.ctrlKey || event.metaKey) {
        window.open(editUrl, '_blank')
      } else {
        this.$router.push(editUrl)
      }
    },

    toggleServiceReq(id) {
      this.$router.push(`/${this.action_module}/${id}/service-req-list`)
    },

    toggleContact(id) {
      this.$router.push(`/${this.action_module}/${id}/contact-us-list`)
    },

    toggleFAQ(id) {
      this.$router.push(`/${this.action_module}/${id}/faq-list`)
    },

    toggleDailyRoutine(id) {
      this.$router.push(`/${this.action_module}/${id}/daily-routine-list`)
    },

    toggleGraphicManage(id) {
      this.$router.push(`/${this.action_module}/${id}/graphics-action`)
    },

    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this record?',
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    async deleteSingleRecord(id) {
      try {
        const { message } = await this.$act('delete', id)
        this.$vs.notify({ title: 'Success', text: message, color: 'success' })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({ title: 'Error', text: message, color: 'primary' })
      }
    },

    updateStatus(id, status) {
      this.$act('updateStatus', { id, status })
        .then(({ message }) => {
          this.getData()
          this.$vs.notify({ title: 'Success', text: message, color: 'success' })
        })
        .catch(({ message }) => {
          this.$vs.notify({ title: 'Error', text: message, color: 'primary' })
        })
    },

    proccedLiveYoutube(id, status) {
      this.$act('youtubeLiveHandle', { id, status })
        .then(({ message }) => {
          this.$vs.notify({ title: 'Success', text: message, color: 'success' })
        })
        .catch(({ message }) => {
          this.$vs.notify({ title: 'Error', text: message, color: 'primary' })
        })
    },

    updateFeaturedStatus(id, status) {
      this.$act('featuredStatus', { id, status })
        .then(({ message }) => {
          this.$vs.notify({ title: 'Success', text: message, color: 'success' })
        })
        .catch(({ message }) => {
          this.$vs.notify({ title: 'Error', text: message, color: 'primary' })
        })
    }
  },

  /** Watchers */
  watch: {
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({ container: '#org-list', scale: 0.45 })
      } else {
        this.$vs.loading.close('#org-list > .con-vs-loading')
      }
    },
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({ container: '#invite-org', scale: 0.45 })
      } else {
        this.$vs.loading.close('#invite-org > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
<style lang="scss">
.locations__actions {
  width: 300px;
}
</style>
